import React, { useEffect, useState } from 'react';
import API from '../API';
import { Groupper, Table } from 'react-frontier';
import { useParams } from 'react-router-dom';
import { PostingInfo } from '../Classes';
import { useTitle, useUser } from '../Hooks';

var UserPostingInvite = ()=>{
   var params = useParams<{ id: string }>();
   var posting_id = parseInt(params?.id);
   var { setTitle } = useTitle();
   var [postingInfo, setPostingInfo] = useState<PostingInfo>(null);
   var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
      API.getPublicPosting(posting_id, false, true , true).then(res=>{
			if(res.error) return setLoadError(res.message);
			setTitle('Invitación de empleo');
			setPostingInfo(res.data.posting);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado cargando la información del empleo. (LCL-1)');
		})
	}, []);
	
	return <div className='tp user-posting-invite-screen'>
      <div>Hellow</div>
	</div>
}

export default UserPostingInvite;